module.exports = __webpack_public_path__ + "static/6597-37559d6d30baf68559a18d543fcd0736.jpg";